import React from "react";
import { MainBg } from "../layouts/MainBg";
import { Formik, Form, Field, ErrorMessage } from "formik";

const ManageSubscription = () => {
  // Inline validation function
  const validate = (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }
    return errors;
  };

  return (
    <MainBg>
      <div className="flex items-center justify-center md:min-h-[calc(100vh-430px)] min-h-[calc(100vh-580px)] px-4">
        <div className="w-full max-w-lg bg-white p-8 rounded-xl">
          <h1 className="text-2xl font-semibold text-center text-gray-800 mb-2">
            Manage Subscription
          </h1>
          <p className="text-center text-blacktxt mb-6">
            If you purchased your subscription on the web, please enter the
            email address you subscribed with in order to change your
            subscription.
          </p>

          <Formik
            initialValues={{ email: "" }}
            validate={validate}
            onSubmit={(values, actions) => {
              console.log("Submitted Email:", values.email);
              actions.resetForm();
            }}
          >
            {({ touched, errors }) => (
              <Form className="space-y-4">
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <Field
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                    className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 ${
                      errors.email && touched.email
                        ? "border-red-500 focus:ring-red-400"
                        : "border-gray-300 focus:ring-orange-500"
                    }`}
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-sm text-red-500 mt-1"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-[#EB5307] text-white font-bold py-3 rounded-lg hover:bg-orange-700 transition-colors"
                >
                  Send
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </MainBg>
  );
};

export default ManageSubscription;
